import { all, fork } from 'redux-saga/effects';
import { watchCreateSpaceTabSaga } from './create-space-tab';
import { watchCreateSpaceTabSuccessSaga } from './create-space-tab-success';
import { watchCreateTaskFromSpaceTabSaga } from './create-task-from-space-tab';
import { watchDeleteSpaceTabSaga } from './delete-space-tab';
import { watchDeleteTaskFromSpaceTabSaga } from './delete-task-from-space-tab';
import { watchFetchSpaceTabSaga } from './fetch-space-tab';
import { watchSpaceTabSuccessSaga } from './space-tab-success';

export function* spaceTabsRootSaga() {
  yield all([
    fork(watchCreateSpaceTabSaga),
    fork(watchCreateSpaceTabSuccessSaga),
    fork(watchDeleteSpaceTabSaga),
    fork(watchFetchSpaceTabSaga),
    fork(watchFetchSpaceTabSaga),
    fork(watchSpaceTabSuccessSaga),
    fork(watchCreateTaskFromSpaceTabSaga),
    fork(watchDeleteTaskFromSpaceTabSaga),
  ]);
}
